/* file description */
import React from 'react';
import { SELECT_MODE, VALUE_TYPES, COLUMN_FROM } from "./consts";
import { TransformNalmalType2TableColumn } from "./type";
import DepUserMemo from '../component/DepUser';
import { Api as FetchAPI } from '@/utils';

export const transformDepUserColumn: TransformNalmalType2TableColumn = ({
  targetColumn,
  field,
  // FetchAPI,
}) => {
  // 是否可以多选
  const isMulti = !!field.isMulti
  
  targetColumn.valueType = VALUE_TYPES.SELECT

  if (isMulti) {
    targetColumn.fieldProps = {
      mode: SELECT_MODE.MULTIPLE
    }
  }

  const { userList } = field?.bizConfig || {};

  // if (isOpenGroup && parentField) {
  //   targetColumn.dependencies= [parentField]
  // }
  targetColumn.renderFormItem = (_a, config, form) => {
    return <DepUserMemo form={form} config={config} field={field} columnFrom={config.from} FetchAPI={FetchAPI} isMulti={isMulti} />;
  };
  targetColumn.render = (dom, entity) => {
    const targerValue = entity?.value
    const findDictItem = userList?.find((item: Record<any,any>) => item.userAccount === targerValue) || {}
    return findDictItem.userName || targerValue
  };
  
  return targetColumn
}